import { useCountry } from '../../components/CountrySelector';
import { useSkippableQuery } from '../useSkippableQuery';
import { useUser } from '../useUser';
import { GET_ORDER_SUMMARY_QUERY } from './orderSummary.rest';

export const useOrderSummary = (orderNumber: string) => {
  const { country } = useCountry();
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error, refetch } = useSkippableQuery(GET_ORDER_SUMMARY_QUERY, {
    variables: { countryCode: country.alpha2Code, orderNumber },
    skip: !orderNumber || !accessToken
  });

  return {
    orderSummary: data?.getOrderSummary?.data?.[0],
    orderItems: data?.getOrderSummary?.included,
    loading,
    error,
    refetch
  };
};
